export default "__VITE_ASSET__C1m$6bP2__"